// Posts and content dictionary
const dictPosts = {
    // Post creation
    create_new_post: {
        th: "สร้างโพสต์ใหม่",
        en: "Create New Post",
        ja: "新規投稿",
    },
    post_target_product: {
        th: "สินค้าเป้าหมาย",
        en: "Target Product",
        ja: "対象商品",
    },
    post_target_product_add: {
        th: "เพิ่ม",
        en: "Add",
        ja: "追加",
    },
    post_target_product_empty: {
        th: "ยังไม่ได้ตั้งค่า",
        en: "Not set",
        ja: "未設定",
    },
    post_status_label: {
        th: "สถานะ",
        en: "Status",
        ja: "ステータス",
    },
    post_status_draft: {
        th: "draft",
        en: "draft",
        ja: "下書き",
    },
    post_status_editing: {
        th: "editing",
        en: "editing",
        ja: "編集中",
    },
    post_status_released: {
        th: "released",
        en: "released",
        ja: "公開",
    },
    post_status_rejected: {
        th: "rejected",
        en: "rejected",
        ja: "却下",
    },
    show_product_information: {
        th: "แสดงข้อมูลสินค้า",
        en: "Show Product Information",
        ja: "商品情報を表示",
    },
    board_btn_submit: {
        th: "โพสต์",
        en: "Submit Post",
        ja: "投稿する",
    },
    board_confirm_content: {
        th: "ยืนยันเนื้อหาโพสต์",
        en: "Confirm Post Content",
        ja: "投稿内容を確認",
    },
    post_create_tabs: {
        th: "แท็บสร้างโพสต์",
        en: "Post creation tabs",
        ja: "投稿作成タブ",
    },
    post_content_chars: {
        th: "ตัวอักษร",
        en: "chars",
        ja: "文字",
    },
    board_search_placeholder: {
        th: "ค้นหาในกระดาน...",
        en: "Search in board...",
        ja: "掲示板内を検索...",
    },

    // Post listing and display
    no_posts_yet: {
        th: "ยังไม่มีโพสต์",
        en: "No posts yet",
        ja: "投稿がありません",
    },
    reviews_posted_from_product_detail: {
        th: "รีวิวจะโพสต์จากหน้ารายละเอียดสินค้าแต่ละรายการ",
        en: "Reviews are posted from each product detail page.",
        ja: "レビュー投稿は各商品詳細ページから投稿します。",
    },
    posted_by: {
        th: "ผู้โพสต์:",
        en: "Posted by:",
        ja: "投稿者:",
    },
    posted_on: {
        th: "โพสต์เมื่อ",
        en: "Posted on",
        ja: "投稿日時",
    },
    updated_on: {
        th: "อัปเดตเมื่อ",
        en: "Updated on",
        ja: "更新日時",
    },
    read_more: {
        th: "อ่านเพิ่มเติม",
        en: "Read More",
        ja: "もっと読む",
    },
    post_content_empty: {
        th: "ยังไม่มีเนื้อหา",
        en: "No content available.",
        ja: "コンテンツはまだありません。",
    },
    editor_loading: {
        th: "กำลังโหลดเอดิเตอร์...",
        en: "Loading editor...",
        ja: "エディタを読み込み中...",
    },
    back_to_list: {
        th: "กลับไปรายการ",
        en: "Back to List",
        ja: "リストに戻る",
    },

    // Post actions
    edit: {
        th: "แก้ไข",
        en: "Edit",
        ja: "編集",
    },
    delete: {
        th: "ลบ",
        en: "Delete",
        ja: "削除",
    },
    posts_delete_confirm: {
        th: "คุณแน่ใจหรือไม่ที่จะลบโพสต์นี้?",
        en: "Are you sure you want to delete this post?",
        ja: "この投稿を削除してもよろしいですか？",
    },
    confirm_delete_post: {
        th: "คุณแน่ใจหรือไม่ที่จะลบโพสต์นี้?",
        en: "Are you sure you want to delete this post?",
        ja: "この投稿を削除してもよろしいですか？",
    },
    posts_delete_error: {
        th: "ไม่สามารถลบโพสต์ได้ กรุณาลองใหม่อีกครั้ง",
        en: "Failed to delete post. Please try again.",
        ja: "投稿を削除できませんでした。再試行してください。",
    },
    title_content_required: {
        th: "จำเป็นต้องมีหัวข้อและเนื้อหา",
        en: "Title and content are required.",
        ja: "タイトルと内容が必要です。",
    },
    title_required: {
        th: "จำเป็นต้องมีหัวข้อ",
        en: "Title is required.",
        ja: "タイトルは必須です。",
    },
    content_required: {
        th: "จำเป็นต้องมีเนื้อหา",
        en: "Content is required.",
        ja: "内容は必須です。",
    },
    back_number_date_required: {
        th: "เมื่อเปิด Back Number ต้องระบุวันที่",
        en: "Date is required when Back Number is on.",
        ja: "Back Number がオンの場合、日付は必須です。",
    },
    post_create_failed: {
        th: "ไม่สามารถสร้างโพสต์ได้",
        en: "Failed to create post",
        ja: "投稿の作成に失敗しました",
    },
    invalid_form_data: {
        th: "ข้อมูลฟอร์มไม่ถูกต้อง",
        en: "Invalid form data.",
        ja: "フォームデータが不正です。",
    },
    title_too_long: {
        th: "หัวข้อต้องมีความยาวไม่เกิน 255 ตัวอักษร",
        en: "Title must be less than 255 characters.",
        ja: "タイトルは255文字未満で入力してください。",
    },
    content_too_long: {
        th: "เนื้อหาต้องมีความยาวไม่เกิน 50,000 ตัวอักษร",
        en: "Content must be less than 50,000 characters.",
        ja: "内容は50,000文字未満で入力してください。",
    },

    // Authentication requirements
    login_required_to_post: {
        th: "โพสต์ใหม่ต้อง",
        en: "Login required to",
        ja: "投稿するには",
    },
    before: {
        th: "ก่อน",
        en: "post",
        ja: "が必要です",
    },

    // General content fields
    title: {
        th: "หัวข้อ",
        en: "Title",
        ja: "タイトル",
    },
    date: {
        th: "วันที่:",
        en: "Date:",
        ja: "日付:",
    },

    // SNS links manager
    sns_links_manager: {
        th: "SNS ลิงก์",
        en: "SNS Links",
        ja: "SNSリンク",
    },
    add_sns_link: {
        th: "เพิ่ม SNS ลิงก์",
        en: "Add SNS Link",
        ja: "SNSリンクを追加",
    },
    sns_links_note_auto: {
        th: "ลิงก์ SNS ที่ป้อนในเนื้อหาจะถูกเพิ่มโดยอัตโนมัติ",
        en: "SNS links entered in content will be added automatically",
        ja: "Contentに入力したSNSリンクが自動的に追加されます",
    },
    tiktok_share_toggle_label: {
        th: "แชร์ไปยัง TikTok",
        en: "Share to TikTok",
        ja: "TikTokへ共有",
    },
    instagram_share_toggle_label: {
        th: "แชร์ไปยัง Instagram",
        en: "Share to Instagram",
        ja: "Instagramへ共有",
    },
    instagram_share_toggle_note: {
        th: "บันทึกโพสต์นี้พร้อมคำขอแชร์ไปยัง Instagram",
        en: "Save this post with an Instagram share request.",
        ja: "この投稿を Instagram 共有リクエスト付きで保存します。",
    },
    tiktok_share_toggle_note: {
        th: "บันทึกโพสต์นี้พร้อมคำขอแชร์ไปยัง TikTok",
        en: "Save this post with a TikTok share request.",
        ja: "この投稿を TikTok 共有リクエスト付きで保存します。",
    },
    sns_share_section_title: {
        th: "แชร์ไปยัง SNS",
        en: "Share to SNS",
        ja: "SNSへ共有",
    },
    unknown: {
        th: "ไม่ระบุ",
        en: "Unknown",
        ja: "不明",
    },

    // Comment integration in posts
    comment_placeholder: {
        th: "แสดงความคิดเห็นของคุณที่นี่...",
        en: "Share your thoughts here...",
        ja: "ここにあなたの意見を書いてください...",
    },
    comment_login_required: {
        th: "ในการแสดงความคิดเห็นต้อง",
        en: "To comment, please",
        ja: "コメントするには",
    },
    comment_login_needed: {
        th: "ก่อน",
        en: "first",
        ja: "してください",
    },
    comment_posted_successfully: {
        th: "โพสต์ความคิดเห็นสำเร็จ",
        en: "Comment posted successfully",
        ja: "コメントを投稿しました",
    },
    comments_post_error: {
        th: "ไม่สามารถโพสต์ความคิดเห็นได้ กรุณาลองใหม่อีกครั้ง",
        en: "Unable to post comment. Please try again.",
        ja: "コメントを投稿できませんでした。再試行してください。",
    },
    comments_content_too_long: {
        th: "ความคิดเห็นยาวเกินไป (สูงสุด 1000 ตัวอักษร)",
        en: "Comment is too long (maximum 1000 characters)",
        ja: "コメントが長すぎます（最大1000文字）",
    },

    // Post success messages
    post_updated: {
        th: "อัปเดตโพสต์เรียบร้อยแล้ว!",
        en: "Post updated successfully!",
        ja: "投稿を更新しました！",
    },
    post_deleted: {
        th: "ลบโพสต์เรียบร้อยแล้ว",
        en: "Post deleted successfully",
        ja: "投稿を削除しました",
    },

    // Error messages
    post_update_error: {
        th: "ไม่สามารถอัปเดตโพสต์ได้ กรุณาลองใหม่อีกครั้ง",
        en: "Failed to update post. Please try again.",
        ja: "投稿を更新できませんでした。再試行してください。",
    },

    // Report functionality
    report_reason: {
        th: "กรุณาระบุเหตุผลในการรายงานโพสต์นี้:",
        en: "Please specify the reason for reporting this post:",
        ja: "この投稿を報告する理由を教えてください：",
    },
    report_submitted: {
        th: "ขอบคุณสำหรับการรายงาน เราจะตรวจสอบโดยเร็วที่สุด",
        en: "Thank you for your report. We will review it shortly.",
        ja: "ご報告ありがとうございます。速やかに確認いたします。",
    },

    // Review agreement
    review_agreement_text_before: {
        th: "ฉันยินยอมให้เผยแพร่รีวิวนี้ และยอมรับ ",
        en: "I agree to publish this review and agree to the ",
        ja: "このレビューを公開し、",
    },
    review_agreement_text_after: {
        th: "",
        en: ".",
        ja: "に同意します。",
    },
    review_agreement_note: {
        th: "บทวิจารณ์ที่เผยแพร่จะแสดงในหน้าสินค้าและเป็นข้อมูลอ้างอิงสำหรับผู้ซื้ออื่น",
        en: "Published reviews will be displayed on the product page and serve as a reference for other buyers.",
        ja: "公開されたレビューは商品ページで表示され、他の購入者の参考になります。",
    },
    review_agree_required: {
        th: "กรุณายินยอมเผยแพร่บทวิจารณ์และยอมรับ Review Guidelines ก่อนโพสต์",
        en: "Please agree to publish the review and accept the Review Guidelines before posting",
        ja: "投稿前にレビュー公開とレビューガイドラインへの同意を行ってください",
    },

    // Review details
    review_details: {
        th: "รายละเอียดบทวิจารณ์",
        en: "Review Details",
        ja: "レビュー詳細",
    },
    view_post_details: {
        th: "ดูรายละเอียด",
        en: "View details",
        ja: "詳細を見る",
    },
    review_rating_star_aria: {
        th: "ดาว {{count}} ดวง",
        en: "{{count}} star{{suffix}}",
        ja: "星{{count}}つ",
    },
    review_of_product: {
        th: "บทวิจารณ์ของ {product} ({rating})",
        en: "Review of {product} ({rating})",
        ja: "{product}のレビュー ({rating})",
    },
    your_rating_label: {
        th: "การประเมินของคุณ:",
        en: "Your rating:",
        ja: "あなたの評価:",
    },
    no_rating_yet: {
        th: "ยังไม่ได้ประเมิน",
        en: "Not rated yet",
        ja: "未評価",
    },

    // WYSIWYG Editor
    wysiwyg_content_placeholder: {
        th: "เขียนเนื้อหาที่นี่...",
        en: "Write your content here...",
        ja: "ここに内容を書いてください...",
    },
    wysiwyg_content_note: {
        th: "💡 วาง URL ได้เลย (ระบบจะตรวจจับอัตโนมัติ)\n✅ SNS URLs จะแสดงใน SNS Links\n📷 วางรูปภาพโดยตรง (Ctrl+V)\n📎 ใช้ปุ่มด้านล่างสำหรับไฟล์เพิ่มเติม",
        en: "💡 Paste URLs directly (auto-detected)\n✅ SNS URLs appear in SNS Links\n📷 Paste images (Ctrl+V)\n📎 Use buttons below for attachments",
        ja: "💡 URLをそのまま貼り付けOK（自動検出）\n✅ SNS URLsはSNS Linksに表示\n📷 画像を直接貼り付け (Ctrl+V)\n📎 追加ファイルは下のボタンを使用",
    },

    // YouTube
    youtube_links: {
        th: "ลิงก์ YouTube",
        en: "YouTube Links",
        ja: "YouTubeリンク",
    },

    // Attachments
    attachment_image: {
        th: "รูปภาพ",
        en: "Image",
        ja: "画像",
    },
    update_button: {
        th: "อัปเดต",
        en: "Update",
        ja: "更新",
    },

    // WYSIWYG notifications
    wysiwyg_uploading: {
        th: "กำลังอัปโหลด...",
        en: "Uploading...",
        ja: "アップロード中...",
    },
    wysiwyg_image_uploaded: {
        th: "อัปโหลดรูปภาพสำเร็จ",
        en: "Image uploaded successfully",
        ja: "画像をアップロードしました",
    },
    wysiwyg_video_uploaded: {
        th: "อัปโหลดวิดีโอสำเร็จ",
        en: "Video uploaded successfully",
        ja: "動画をアップロードしました",
    },
    wysiwyg_image_deleted: {
        th: "ลบรูปภาพสำเร็จ",
        en: "Image deleted successfully",
        ja: "画像を削除しました",
    },
    wysiwyg_media_delete_failed: {
        th: "ลบสื่อไม่สำเร็จ",
        en: "Media delete failed",
        ja: "メディアの削除に失敗しました",
    },
    post_create_files_skipped_invalid_type_or_size: {
        th: "บางไฟล์ถูกข้ามเนื่องจากชนิดไฟล์หรือขนาดไม่ตรงตามข้อกำหนด",
        en: "Some files were skipped due to type or size restrictions",
        ja: "ファイル形式またはサイズ制限により、一部のファイルはスキップされました",
    },
    post_create_process_images_failed: {
        th: "ไม่สามารถประมวลผลรูปภาพได้",
        en: "Failed to process images",
        ja: "画像の処理に失敗しました",
    },
    post_create_process_videos_failed: {
        th: "ไม่สามารถประมวลผลวิดีโอได้",
        en: "Failed to process videos",
        ja: "動画の処理に失敗しました",
    },
    post_create_preview_failed: {
        th: "ไม่สามารถสร้างพรีวิวได้",
        en: "Failed to generate preview",
        ja: "プレビューの生成に失敗しました",
    },
    post_created_successfully: {
        th: "โพสต์ถูกสร้างเรียบร้อยแล้ว",
        en: "Post created successfully!",
        ja: "投稿を作成しました",
    },
    wysiwyg_confirm_delete: {
        th: "ลบรูปภาพ {filename} หรือไม่?",
        en: "Delete image {filename}?",
        ja: "画像 {filename} を削除しますか？",
    },
    wysiwyg_image_size_label: {
        th: "ขนาดรูปภาพ",
        en: "Image size",
        ja: "画像サイズ",
    },
    wysiwyg_image_float_left: {
        th: "ล้อมข้อความ (ซ้าย)",
        en: "Wrap text (left)",
        ja: "回り込み（左）",
    },
    wysiwyg_image_float_center: {
        th: "กึ่งกลาง",
        en: "Center",
        ja: "中央寄せ",
    },
    wysiwyg_image_float_right: {
        th: "ล้อมข้อความ (ขวา)",
        en: "Wrap text (right)",
        ja: "回り込み（右）",
    },
    wysiwyg_image_float_none: {
        th: "ไม่ล้อมข้อความ",
        en: "No wrap",
        ja: "回り込み解除",
    },
    wysiwyg_insert_product: {
        th: "แทรกสินค้า",
        en: "Insert product",
        ja: "商品を挿入",
    },

    // Recommend modal
    post_recommend_rank_title: {
        th: "อันดับแนะนำ",
        en: "Recommended Rank",
        ja: "おすすめ順位",
    },
    post_recommend_close: {
        th: "ปิด",
        en: "Close",
        ja: "閉じる",
    },
    post_recommend_tooltip: {
        th: "โพสต์แนะนำ",
        en: "Recommended post",
        ja: "おすすめ投稿",
    },
    post_recommend_error_load: {
        th: "โหลดข้อมูลแนะนำไม่สำเร็จ",
        en: "Failed to load recommend info",
        ja: "おすすめ情報の取得に失敗しました",
    },
    post_recommend_error_update: {
        th: "อัปเดตอันดับแนะนำไม่สำเร็จ",
        en: "Failed to update recommend rank",
        ja: "おすすめ順位の更新に失敗しました",
    },
    post_recommend_error_unset: {
        th: "ยกเลิกการแนะนำไม่สำเร็จ",
        en: "Failed to unset recommend",
        ja: "おすすめの解除に失敗しました",
    },
    post_recommend_remove_all_confirm: {
        th: "ลบอันดับแนะนำทั้งหมดหรือไม่?",
        en: "Clear all recommended ranks?",
        ja: "おすすめ順位をすべて解除しますか？",
    },
    post_recommend_error_clear: {
        th: "ลบอันดับแนะนำทั้งหมดไม่สำเร็จ",
        en: "Failed to clear recommends",
        ja: "おすすめの全解除に失敗しました",
    },

    // Post detail: recommended products section
    post_recommended_products_title: {
        th: "สินค้าแนะนำ",
        en: "Recommended Products",
        ja: "おすすめ商品",
    },
};

export { dictPosts };
